<template>
  <div class="content">
      <PageHeader style="margin:10px 0 0 0;"/>
      <div class="page_searcher">
          <Searcher :items="config.searchers" @search="getData" ref="searcher"/>
      </div>
      <div class="page_block" v-for="(mod, index) in datas" :key="`mod_${index}`" :style="mod.module_style">
        <div class="page_block_content">
            <h3 v-html="`${mod.name?mod.name:mod.title?mod.title:''}${mod.desc?`<div style='color: #999; font-size: 13px; font-weight: normal; margin-left: 30px; display:inline-block'>${mod.desc}</div>`:''}`"></h3>
            
            <h3 v-if="mod.no_chart!=true">
                <ChartTrans v-if="mod.chart.summary && mod.chart.type!='mixin'" :fields="mod.fields" :chart="mod.chart" :datas="mod.datas" v-model="mod.trans_chart"  style="float:right"/>
            </h3>
            <Chart v-if="mod.no_chart!=true" :datas="mod.trans_chart?mod.trans_chart.data:mod.datas" :fields="mod.fields" :conf="mod.trans_chart?mod.trans_chart.config:mod.chart" :height="400"/>
            <a-divider dashed style="margin:20px 0 10px 0" v-if="mod.no_chart!=true && mod.no_table!=true"/>
            <div v-if="mod.no_table!=true" style="overflow: hidden">
                <a-button-group style="float:right; margin:0 0 10px 10px" >
                    <a-button @click="lockHeader(index)" :type="locks.indexOf(index)>=0?'primary':null"><a-icon type="lock" />{{locks.indexOf(index)>=0?$t("common.cancelFix"):$t("common.fixHead")}}</a-button>
                    <a-button @click="exportToExcel(index)"><a-icon type="download"/>{{$t("common.downloadData")}}</a-button>
                    <a-button @click="copy(index)" id="copy-btn"><a-icon type="copy"/>{{$t("common.copyData")}}</a-button>
                </a-button-group>
              <div style="float:right; margin:0 0 10px 10px" v-if="mod.no_table!=true">
                隐藏列：
                <a-select style="width: 400px" v-model="hidden_fields[index]" mode="multiple">
                  <a-select-option v-for="field in mod.fields" :key="`${field.id}`">
                      {{field.title}}{{field.desc?`-${field.desc}`:''}}
                  </a-select-option>
                </a-select>
              </div>
            </div>
            
            <DataTable  v-if="mod.no_table!=true" :liucun="mod.liucun" :fields="filter_fields[index]" :theads="mod.theads" 
            :datas="mod.datas" :ref="`datatable_${index}`" :pageSize="mod.pageSize!=null?mod.pageSize:config.pageSize" :marks="marks" :color="mod.color?mod.color:config.color" :xlen="mod.xlen"  :small="true"/>
        </div>
      </div>
  </div>
</template>  

<script>
import PageHeader from '@/components/game/pageheader.vue';
import {ctrlMixin} from '@/utils/ctrlMixin.js'
import Searcher from '@/components/common/search/searcher.vue'
import DataTable from '@/components/common/datatable.vue'
import Chart from '@/components/common/chart/chart.vue'
import ChartTrans from '@/components/common/chart/chart_trans.vue'
import Mark from '@/components/common/chart/mark.vue'
import {Input} from 'ant-design-vue';
import Vue from 'vue'
Vue.use(Input)

export default {
  mixins: [ctrlMixin],
  components: {
      Searcher,
      DataTable,
      Chart,
      Mark,
      ChartTrans,
      PageHeader
  },
  computed: {
    filter_fields() {
      return this.datas.map((d, i)=>{
        if(d.fields) {
          const _hiddens = this.hidden_fields.length > i ? this.hidden_fields[i] : []
          return d.fields.filter(f=>{
            return _hiddens.indexOf(f.id) < 0
          })
        }
        else {
          return []
        }
      })
    }
  },
  methods: {
      // 获取页面数据
      getData(params) {
          this.loading = true
          let datas = []
          const _hidden_fields = [...this.hidden_fields]
          this.$service.query(this.queryId, params).then((data)=>{
            data.forEach((row, index)=>{
                if(_hidden_fields.length <= index) {
                  _hidden_fields.push([])
                }
                if(this.modules.length > index) {
                  if(row instanceof Array) {
                    datas.push({...this.modules[index], datas: row})
                  }
                  else {
                    datas.push({...this.modules[index], ...row})
                  }
                }
                else {
                  if(!(row instanceof Array)) {
                    datas.push(row)
                  }
                }
              })
              this.datas = datas
              this.loading = false
              this.hidden_fields = _hidden_fields
          }).catch((data)=> {
              this.datas = datas
              this.loading = false
          })
          
      }
  },
  data() {
      return {
          datas:[],
          current:0,
          hidden_fields:[[]]
      }
  },
}
</script>